



































































































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import axios, { AxiosResponse } from 'axios'
import { getMobileOperatingSystem, MobilePlatform } from '@/utils/mobile'

@Component
export default class GetMobileAppDialog extends Vue {
  @PropSync('visible', { type: Boolean })
  isVisible!: boolean

  @Watch('isVisible')
  async onVisibilityChanged(visible: boolean) {}

  @Prop({ type: Boolean, default: false }) noFullscreen!: boolean
  @Prop({ type: Boolean, default: false }) dense!: boolean

  // show the download option with applicable platform only (eg. iPhone = App store)
  @Prop({ type: Boolean, default: false }) applicableOnly!: boolean

  get mobileOperatingSystem() {
    return getMobileOperatingSystem()
  }

  get MobilePlatform() {
    return MobilePlatform
  }
}
